import ErrorBoundary from './ErrorBoundary';
import NiceModal from '@ebay/nice-modal-react';
import Routes from './Routes';
import { SEO } from '../components';
import { ThemeProvider } from 'styled-components';
import { usePrefetchAppVersion } from 'utils/hooks';

export function App({ theme }) {
    usePrefetchAppVersion();

    return (
        <ThemeProvider theme={theme}>
            <SEO />
            <ErrorBoundary>
                <NiceModal.Provider>
                    <Routes />
                </NiceModal.Provider>
            </ErrorBoundary>
        </ThemeProvider>
    );
}

export default App;
